<template>
	<div class="d-flex align-center">
		<div
			v-if="menuOpen"
			style="position: fixed;height: 100vh;width:100vw;top:0;left:0;z-index: 8;background-color: rgba(0,0,0,0.2);"
			@click="menuOpen = false"
			></div>
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="700"
			max-width="700"
			content-class="container-notification-menu-header"
			:close-on-content-click="false"
			:close-on-click="false"
			@input="changeMenu"
		>
			<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
						<v-btn
							outlined
							dark
							small
							color="#959595"
							v-bind="{ ...tooltipAttrs, ...menuAttrs }"
							v-on="{ ...tooltipOn, ...menuOn }"
						>
							<v-icon dark>mdi-cog-outline</v-icon>
							<p class="mb-0 ml-1" v-if="$vuetify.breakpoint.width > 1500">Configuración</p>
						</v-btn>
					</template>
					<span>Configuración</span>
				</v-tooltip>
			</template>
			<div class="white" style="position: relative;">
				<div class="d-flex justify-space-between grey darken-3 px-4 py-1">
					<p class="mb-0 caption white--text">Configuración</p>
					<v-btn
						icon
						dark
						x-small
						color="white"
						@click="changeMenu(false)"
					>
						<v-icon dark>mdi-close</v-icon>
					</v-btn>
				</div>
				<v-btn-toggle
					v-model="tab"
					dense
					tile
					mandatory
					class="d-flex flex-row custom-toggle-btns"
				>
					<v-btn :value="0" class="flex-grow-1"
						:color="tab == 0 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 0 ? 'white--text':''">General</p>
						</div>
					</v-btn>
					<v-btn :value="1" class="flex-grow-1"
						:color="tab == 1 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 1 ? 'white--text':''">Proyectos / Especialidades</p>
						</div>
					</v-btn>
					<v-btn :value="2" class="flex-grow-1"
						:color="tab == 2 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 2 ? 'white--text':''">Tipos de Estructura</p>
						</div>
					</v-btn>
					<v-btn :value="3" class="flex-grow-1"
						:color="tab == 3 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 3 ? 'white--text':''">Porcentajes de Patrocinio</p>
						</div>
					</v-btn>
				</v-btn-toggle>
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<div>
							<div class="my-2 px-4">
								<p class="mb-0 font-weight-bold body-2 mb-0" style="color: #524D4D">Opciones Generales</p>
								<p class="mb-0 mb-0" style="color: #524D4D;font-size: 10px;">Modificar estas opciones sólo afectará a la tabla activa</p>
								<v-divider class="mt-1 mb-3"></v-divider>
								<div class="d-flex flex-row align-center justify-space-between">
									<p class="mb-0 font-weight-bold caption" style="color: #524D4D">Tipo de Impuesto</p>
									<div class="d-flex align-center">
										<v-select
											:value="costsTable.company_tax_id"
											:items="taxOptions"
											:loading="$store.state.general.loadingTaxesOptions"
											:menu-props="{ top: true, offsetY: true }"
											item-text="name"
											item-value="id"
											label="Tipo Impuesto"
											class="custom-height-search custom-height-calendar flex-grow-0"
											style="width: 220px"
											outlined
											dense
											required
											return-object
											@change="changeTaxSelection"
										>
											<template v-slot:item="data">
												<v-list-item-content>
													<v-list-item-title>
														<div class="d-flex align-center justify-space-between">
															<div class="d-flex align-center justify-space-between flex-1">
																<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
																<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item-content>
											</template>
											<template v-slot:selection="data">
												<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
													<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
													<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
												</div>
											</template>
										</v-select>
									</div>
								</div>
								<div class="d-flex flex-row align-center justify-space-between mt-3">
									<div>
										<p class="mb-0 font-weight-bold caption" style="color: #524D4D">Seleccione Moneda</p>
										<p class="mb-0 text--disabled" style="color: #524D4D;font-size: 10px;">Esta será la moneda con la que trabajarás la Tabla de Costo</p>
									</div>
									<div class="d-flex align-center">
										<v-btn-toggle
											v-model="costsTable.currency"
											color="red"
											dense
											mandatory
											borderless
										>
											<v-btn :value="1" text plain style="min-width: 30px;height:auto;" class="pa-0 font-weight-bold" small>
												UF
											</v-btn>
											<v-btn :value="2" text plain style="min-width: 30px;height:auto;" class="pa-0 font-weight-bold" small>
												CLP
											</v-btn>
										</v-btn-toggle>
									</div>
								</div>
							</div>
						</div>
					</v-tab-item>
					<v-tab-item>
						<div>
							<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-4">
								<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Proyectos / Especialidades</p>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon color="grey" class="mr-3"
											v-bind="attrs"
											v-on="on"
											small
											v-if="$checkPermissions(['create_company_project_specialties'])"
											@click="setCostCategory(null)">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<span>Nueva Especialidad</span>
								</v-tooltip>
							</div>
							<v-divider class="my-2"></v-divider>
							<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
								<v-list-item
									v-for="(item, i) in costSpecialties"
									:key="i"
									class="px-0 py-0"
								>
									<div style="width: 100%">
										<div class="d-flex flex-row px-4 justify-space-between">
											<div class="px-4 caption">
												<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.name }}</p>
											</div>
											<div>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="warning"
															v-if="$checkPermissions(['create_company_project_specialties'])"
															@click="setCostCategory(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-pencil</v-icon>
														</v-btn>
													</template>
													<span>Editar Especialidad</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="error"
															v-if="$checkPermissions(['delete_company_project_specialties'])"
															@click="deleteCategory(item)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Especialidad</span>
												</v-tooltip>
											</div>
										</div>
									</div>
								</v-list-item>
							</v-list>
						</div>
					</v-tab-item>
					<v-tab-item>
						<div>
							<CompanyMaterialsConfig />
						</div>
					</v-tab-item>
					<v-tab-item>
						<div>
							<CompanySupervisionPercentConfig />
						</div>
					</v-tab-item>
				</v-tabs-items>
			</div>
			<v-divider class="mx-2"></v-divider>
		</v-menu>
	</div>
</template>

<script>
// import _debounce from 'lodash/debounce'
import {deleteCostSpecialtyCompany, deleteCostSubCategoryCompany, deleteCostItemCompany} from '@/helpers/api/costs'
import {deleteTaxOption} from '@/helpers/api/general'
import CompanyMaterialsConfig from '@/components/Views/Companies/CompanyMaterialsConfig'
import CompanySupervisionPercentConfig from '@/components/Views/Companies/CompanySupervisionPercentConfig'

export default {
  name: 'CostBreakdownSettings',
	components: {
		CompanyMaterialsConfig,
		CompanySupervisionPercentConfig
	},
	props: {
		changeTaxSelection: {
			type: Function,
			required: true
		},
		costsTable: {
			type: Object,
			required: true
		},
	},
  data: () => ({
		menuOpen: false,
		selectedCostCategoryId: null,
		selectedCostSubCategoryId: null,
		tab: null,
    validform: true,
		loadingData: false,
    newBudgetConcept: {
			budget_concept_id: null,
			name: null
    },
		acceptRejectModal: false,
		acceptRejectModalData: null,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		costSubCategories(){
			if(this.selectedCostCategoryId){
				const subcategories = this.costCategories.find(item => item.id === this.selectedCostCategoryId)
				return subcategories ? subcategories.subcategories : []
			}
			return []
		},
		costGeneralSubCategories(){
			return this.$store.state.costbreakdown.companiesCostGeneralSubCategories
		},
		costItems(){
			if(this.costSubCategories && this.selectedCostSubCategoryId){
				let costs = this.costSubCategories.find(item => item.id === this.selectedCostSubCategoryId)
				if(!costs){
					costs = this.costGeneralSubCategories.find(item => item.id === this.selectedCostSubCategoryId)
				}
				return costs ? costs.items : []
			}
			return []
		}
  },
	watch: {
		// selectedTax(newValue){
		// 	if(newValue){

		// 	}
		// },
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('costbreakdown/getCompanySpecialties')
				this.$store.dispatch('costbreakdown/getCompanyCostItems')
				this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
			}
		},
	},
  mounted(){
		if(this.$store.state.budget.newBudgetConceptModalEditing){
			this.newBudgetConcept = this.$store.state.budget.newBudgetConceptModalEditing
		}
		if(this.selectedCompany){
			this.$store.dispatch('costbreakdown/getCompanySpecialties')
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
			this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
		}
  },
  methods: {
		startEditTax(item){
			let modalData = item
			if(modalData){
				modalData = {...modalData, ...{company_tax_id: item.id}}
			}
			this.$store.commit('general/setTaxesOptionsModalEditting', modalData)
			this.$store.commit('general/setTaxesOptionsModal', true)
		},
		async deleteTax(item){
			if(item){
				const data = {company_tax_id: item.id}
				await deleteTaxOption(data)
				this.$store.dispatch('general/getTaxesOptions')
			}
		},
		setSelectedCostCategory(item){
			this.selectedCostCategoryId = item.id
			this.tab = 1
		},
		setSelectedCostSubCategory(item){
			console.log('item', item)
			// this.selectedCostSubCategoryId = item.id
			// this.tab = 2
		},
		changeMenu(value){
			this.menuOpen = value
		},
		setCostCategory(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownCategoryModal', true)
			if(item){
				this.$store.commit('costbreakdown/setNewCostBreakdownCategoryModalEditing', {...item, ...{company_cost_category_id: item.id}})
			}
		},
		setCostSubCategory(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownSubCategoryModal', true)
			let data = {company_cost_category_id: this.selectedCostCategoryId}
			if(item){
				data = {...data, ...item, ...{company_cost_subcategory_id: item.id}}
			}
			this.$store.commit('costbreakdown/setNewCostBreakdownSubCategoryModalEditing', data)
		},
		setCostConcept(item){
			this.$store.commit('costbreakdown/setNewCostBreakdownItemModal', true)
			let data = {company_cost_subcategory_id: this.selectedCostSubCategoryId}
			if(item){
				data = {...data, ...item, ...{company_cost_item_id: item.id}}
			}
			this.$store.commit('costbreakdown/setNewCostBreakdownItemModalEditing', data)
		},
		async deleteCategory(item){
			await deleteCostSpecialtyCompany({company_cost_category_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostSpecialties')
		},
		async deleteSubcategory(item){
			await deleteCostSubCategoryCompany({company_cost_subcategory_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
		},
		async deleteConcept(item){
			await deleteCostItemCompany({company_cost_item_id: item.id})
			this.$store.dispatch('costbreakdown/getCompanyCostItems')
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.handle_drag{
		cursor: move;
	}
	.selected{background-color: #ececec;}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>